/** Aadhaar verified via APITxt OTP (no photo upload). */
export function isOtpKycRecord(item) {
  if (!item || typeof item !== "object") return false;
  if (item.kycMethod === "otp") return true;
  const front = String(item.front || "");
  return front.includes("otp-kyc") || front.includes("placeholder");
}

export function hasKycDocumentImages(item) {
  if (isOtpKycRecord(item)) return false;
  const front = String(item.front || "").trim();
  const back = String(item.back || "").trim();
  if (!front || !back) return false;
  return !front.includes("placeholder") && !back.includes("placeholder");
}

export function formatAadhaarNumber(num) {
  const digits = String(num ?? "").replace(/\D/g, "");
  if (digits.length === 12) {
    return `${digits.slice(0, 4)} ${digits.slice(4, 8)} ${digits.slice(8)}`;
  }
  return digits || "—";
}

export function kycDocumentImageSrc(baseUrl, path) {
  if (!path) return null;
  const p = String(path).trim();
  if (p.includes("otp-kyc") || p.includes("placeholder")) return null;
  if (!p) return null;
  if (p.startsWith("http://") || p.startsWith("https://")) return p;
  const root = String(baseUrl || "").replace(/\/+$/, "");
  const rel = p.startsWith("/") ? p.slice(1) : p;
  return `${root}/${rel}`;
}

export function kycMethodLabel(item) {
  return isOtpKycRecord(item) ? "Online OTP" : "Manual upload";
}
